{
  "attachFile": "Attach file",
  "attachmentLimits": "Up to {{ MAX_FILE_SIZE_MB }} MB per file, up to {{ MAX_FILES_COUNT }} files",
  "cancel": "Cancel",
  "dragFilesHere": "Drag files here,\nto attach them to a post",
  "errorRetry": "Error, try again",
  "fewFilesUploadFailed": "We were unable to load some files, delete them and try again",
  "fileIsTooBig": "File \"{{ name }}\" is over {{ MAX_FILE_SIZE_MB }} MB. Make it smaller or send a link to it in cloud storage.",
  "maxFileCountError": "Only {{ MAX_FILES_COUNT }} files can be attached to a message",
  "save": "Save",
  "submit": "Send",
  "uploadError": "An error has occurred while sending data over the network",
  "videoIsTooBig": "Video \"{{ name }}\" is over {{ MAX_FILE_SIZE_MB }} MB. Compress it or upload it to a video service and send the link.",
  "waitUntilFilesUploaded": "Wait until all files are loaded"
}
